import { useMutation } from "@tanstack/react-query";
import { getBrandingByDomainName } from "controller/api";

export const useGetBrandingByDomainName = () => {
  return useMutation((domainName: string) =>
    getBrandingByDomainName(domainName)
  );
};
